<div class="flex w-full flex-col">
  <!-- header -->
  <div class="flex items-center justify-between px-6 pb-4 pt-6">
    <div class="flex items-center gap-2">
      <mat-icon class="text-primary">price_change</mat-icon>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.UNPRICED_UOM_MODAL.TITLE' | t }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- producto -->
  <div class="bg-primary-50 px-6 py-3 dark:bg-primary-900/10">
    <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.PRODUCT' | t }}</span>
    <div class="text-primary font-semibold">{{ data.productLabel }}</div>
  </div>

  <!-- mensaje + cantidad -->
  <div class="px-6 py-4">
    <p class="text-base"
      [innerHTML]="'DOCUMENT_GENERATE.UNPRICED_UOM_MODAL.MESSAGE' | t: { unit: data.selectedUnitName, baseUnit: data.baseUnitName }"></p>

    <label class="text-secondary mt-4 block text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.QUANTITY_IN' | t: { unit: data.selectedUnitName } }}</label>
    <input type="text" inputmode="decimal" [ngModel]="amountText" (ngModelChange)="onAmountInput($event)" placeholder="0"
      class="mt-1 w-full rounded-lg border px-3 py-2 text-lg outline-none focus:border-primary dark:bg-transparent">

    @if (amount > 0) {
    <div class="mt-3 rounded-xl border border-primary-100 bg-primary-50 px-4 py-3 dark:border-primary-900/40 dark:bg-primary-900/10">
      <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.UNPRICED_UOM_MODAL.WILL_REGISTER_AS' | t }}</span>
      <div class="text-primary text-2xl font-bold">{{ converted | number:'1.0-3' }} {{ data.baseUnitName }}</div>
      <div class="text-secondary text-sm">{{ amount | number:'1.0-3' }} {{ data.selectedUnitName }}</div>
    </div>
    }
  </div>

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="converted <= 0" (click)="confirm()">
      {{ 'DOCUMENT_GENERATE.ACTIONS.CONFIRM' | t }}
    </button>
  </div>
</div>
